import { createContext, useContext, useMemo, type ReactNode } from "react"
import { configuredRelays } from "./branding"
import { DEFAULT_CONFIG } from "./defaults"
import type { AppConfig, LoadedConfig } from "./types"

const ConfigContext = createContext<LoadedConfig | undefined>(undefined)

export function ConfigProvider({ value, children }: { value: LoadedConfig; children: ReactNode }) {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
}

export function useConfigMeta(): LoadedConfig {
  const context = useContext(ConfigContext)
  return context ?? { config: DEFAULT_CONFIG, warnings: [], sources: ["defaults"] }
}

export function useConfig(): AppConfig {
  return useConfigMeta().config
}

/** Configured relay lists, normalised once per configuration object. */
export function useConfiguredRelays() {
  const config = useConfig()
  return useMemo(() => configuredRelays(config), [config])
}

export function useBranding() {
  return useConfig().branding
}

export function useFeatures() {
  return useConfig().features
}
